/* eslint-disable */
import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default props => {
  return (
    <SvgIcon {...props}>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="home"
          transform="translate(-102.000000, -737.000000)"
          stroke="currentColor"
        >
          <g
            id="iPhone-X/Bars/Tab-Bar/5-Items"
            transform="translate(0.000000, 722.000000)"
          >
            <g id="Item-2" transform="translate(89.000000, 9.000000)">
              <g id="Icon">
                <g id="Group-89" transform="translate(14.000000, 7.000000)">
                  <path
                    d="M11.25,3.75 C11.25,4.67083333 10.5041667,5.41666667 9.58333333,5.41666667 C8.6625,5.41666667 7.91666667,4.67083333 7.91666667,3.75 C7.91666667,2.82916667 8.6625,2.08333333 9.58333333,2.08333333 C10.5041667,2.08333333 11.25,2.82916667 11.25,3.75 L11.25,3.75 Z"
                    id="Stroke-83"
                  ></path>
                  <polyline
                    id="Stroke-85"
                    points="7.09291667 6.46075 6.24958333 6.24991667 6.24958333 17.9165833 12.91625 19.58325 12.91625 7.91658333 11.5554167 7.57658333"
                  ></polyline>
                  <path
                    d="M12.9166667,3.75 C12.9166667,5.59083333 9.58333333,11.25 9.58333333,11.25 C9.58333333,11.25 6.25,5.59083333 6.25,3.75 C6.25,1.90916667 7.7425,0.416666667 9.58333333,0.416666667 C11.4241667,0.416666667 12.9166667,1.90916667 12.9166667,3.75 L12.9166667,3.75 Z"
                    id="Stroke-87"
                  ></path>
                  <polygon
                    id="Stroke-81"
                    points="6.25 17.9166667 0.416666667 19.5833333 0.416666667 7.91666667 6.25 6.25"
                  ></polygon>
                  <polygon
                    id="Stroke-82"
                    points="19.5833333 17.9166667 12.9166667 19.5833333 12.9166667 7.91666667 19.5833333 6.25"
                  ></polygon>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
